import React from 'react';

import NotAuthenticatedController from './not-authenticated.controller';

const NotAuthenticatedScreen: React.FC = () => {
  return <NotAuthenticatedController />;
};

export default NotAuthenticatedScreen;
